import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { EXAM_KIND } from '../../utils/const'
import { setCertData } from '../../actions/certification'
import Filters from './Filters'
import Table from './Table'
import styles from './styles.module.scss'

// Единый компонент режимов «Промежуточная аттестация» (examKind = 2)
// и «Итоговая аттестация» (examKind = 3).
const Certification = ({ examKind }) => {
  const dispatch = useDispatch()

  // При смене режима не показывать таблицу другого вида аттестации.
  useEffect(() => () => dispatch(setCertData(null)), [dispatch, examKind])

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>
          {examKind === EXAM_KIND.FINAL ? 'Итоговая аттестация' : 'Промежуточная аттестация'}
        </h1>
        <Filters examKind={examKind} />
        <Table examKind={examKind} />
      </div>
    </div>
  )
}

export default Certification
